export default __webpack_public_path__ + "static/media/Panel_6_Stage1.678f2b82.svg";